import { matchPath } from "react-router-dom";

import * as Sentry from "@sentry/browser";

import { navigationRoutingRegistry } from "../navigationRouting";
import type { GetPageNameForTrackingFromCrossroadsRequestOptions, NavigationRoutingMatch } from "./types";

const getNavigationRoutingMatchForPath = (pathname: string): NavigationRoutingMatch | undefined => {
  for (const [nroPathname, nro] of Object.entries(navigationRoutingRegistry)) {
    const match = matchPath(nroPathname, pathname);

    if (match) {
      const params: Record<string, string> = {};

      Object.entries(match.params).forEach(([key, value]) => {
        if (value !== undefined) {
          params[key] = value;
        }
      });

      return { nro, params };
    }
  }

  return undefined;
};

export const getPageNameForTrackingFromCrossroadsRequest = ({
  request,
  appGroupId,
  featureOn,
}: GetPageNameForTrackingFromCrossroadsRequestOptions): string | undefined => {
  try {
    const [pathname] = request.split(/[?#]/);
    const candidatePathnames = appGroupId ? [pathname, `${pathname}/${appGroupId}`] : [pathname];

    for (const candidatePathname of candidatePathnames) {
      const match = getNavigationRoutingMatchForPath(candidatePathname);

      if (match?.nro.pageNameForTracking) {
        return match.nro.pageNameForTracking({
          featureOn,
          params: match.params,
        });
      }
    }

    return undefined;
  } catch (error) {
    Sentry.captureException(error, {
      extra: {
        appGroupId,
        request,
      },
    });

    return undefined;
  }
};
